var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"page-spacing pa-0"},[_c('v-col',{attrs:{"cols":"12"}},[(!_vm.yonlendiriliyor)?_c('yetki-gecisi-ekrani',{on:{"kapat":_vm.izinlereDon,"tamamlandi":_vm.izinlereDon}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }